import React from "react";
import { Layout } from "antd";
import "./LogInHeader.scss";

const { Header, Content } = Layout;

function LogInHeader() {
    return (
        <Header className="sign-up-header justify-in-center">
            <div className="cursor-pointer" onClick={() => window.location.href = 'https://all3d.ai/'}>
                <img src={require("../../assets/images/all3d-new-logo-red.svg")}/>
            </div>
        </Header>
    );
}


export default LogInHeader;
